aracwebshop.bind_product_filter_shell = function() {
	const $sidebar = $("#filter-sidebar");
	const $backdrop = $("#filter-backdrop");
	const $button = $("#filter-toggle-btn");

	if (!$sidebar.length || !$button.length) return;

	const is_desktop = () => window.innerWidth >= 768;
	const set_button_label = (label) => {
		$button.find("span").text(__(label));
	};
	const update_grid = () => {
		$("#products-grid-area")
			.removeClass("lg:grid-cols-3 lg:grid-cols-4")
			.addClass("arac-product-grid");
	};

	function open_filters() {
		$("#anti-fouc-style").remove();
		$sidebar
			.removeClass("hidden md:hidden d-none")
			.addClass("md:block");
		$backdrop.removeClass("hidden");
		$("body").addClass("mobile-drawer-open");
		setTimeout(() => {
			$backdrop.addClass("opacity-100");
			$sidebar.removeClass("-translate-x-full");
		}, 20);
	}

	function close_filters() {
		$sidebar.addClass("-translate-x-full");
		$backdrop.removeClass("opacity-100");
		$("body").removeClass("mobile-drawer-open");
		setTimeout(() => {
			$backdrop.addClass("hidden");
		}, 300);
	}

	function sync_filter_state() {
		if (!is_desktop()) {
			set_button_label("Filters");
			$sidebar
				.removeClass("hidden md:hidden d-none md:block")
				.addClass("-translate-x-full");
			$backdrop.addClass("hidden").removeClass("opacity-100");
			$("body").removeClass("mobile-drawer-open");
			return;
		}

		const filters_hidden = localStorage.getItem("hide_filters") === "true";
		$("#anti-fouc-style").remove();
		$sidebar.removeClass("-translate-x-full");

		if (filters_hidden) {
			$sidebar.removeClass("md:block d-block").addClass("md:hidden hidden");
			set_button_label("Show Filters");
		} else {
			$sidebar.removeClass("md:hidden hidden d-none").addClass("md:block");
			$sidebar.css("display", "");
			set_button_label("Hide Filters");
		}

		update_grid();
	}

	$(document)
		.off("click.product_filter_shell click.all_products_filters click.item_group_filters", "#filter-toggle-btn")
		.on("click.product_filter_shell", "#filter-toggle-btn", function(event) {
			event.preventDefault();

			if (!is_desktop()) {
				if ($sidebar.hasClass("-translate-x-full") || !$sidebar.is(":visible")) {
					open_filters();
				} else {
					close_filters();
				}
				return;
			}

			const should_hide = !$sidebar.hasClass("hidden") && !$sidebar.hasClass("md:hidden");
			localStorage.setItem("hide_filters", should_hide ? "true" : "false");
			sync_filter_state();
		});

	$(document)
		.off("click.product_filter_shell", "#mobile-filter-close, #filter-backdrop")
		.on("click.product_filter_shell", "#mobile-filter-close, #filter-backdrop", close_filters);

	$(window)
		.off("resize.product_filter_shell")
		.on("resize.product_filter_shell", frappe.utils.debounce(sync_filter_state, 120));

	sync_filter_state();
};

aracwebshop.ProductView =  class {
	/* Options:
		- View Type
		- Products Section Wrapper,
		- Item Group: If its an Item Group page
	*/
	constructor(options) {
		Object.assign(this, options);
		this.preference = localStorage.getItem("product_view") || this.view_type || "Grid View";
		this.start = 0;
		this.isLoading = false;
		this.hasMore = true;
		this.product_count = null;
		this.product_settings = null;
		this.loaded_products = [];
		this.loaded_product_codes = new Set();
		this.rendered_product_codes = {grid: new Set(), list: new Set()};
		this.request_generation = 0;
		this.scroll_check_scheduled = false;
		this.product_image_observer = null;
		this.make();
		this.bind_infinite_scroll();
	}

	make(from_filters=false) {
		this.reset_product_image_observer();
		this.request_generation += 1;
		this.start = 0;
		this.isLoading = false;
		this.hasMore = true;
		this.product_count = null;
		this.product_settings = null;
		this.loaded_products = [];
		this.loaded_product_codes = new Set();
		this.rendered_product_codes = {grid: new Set(), list: new Set()};
		this.products_section.empty();
		this.prepare_toolbar();
		this.get_item_filter_data(from_filters);
	}

	prepare_toolbar() {
		this.products_section.append(`
			<div class="toolbar flex flex-row justify-between items-center gap-3 bg-white p-2.5 md:p-3.5 rounded-[1.5rem] border border-slate-100/80 shadow-[0_8px_30px_rgba(0,0,0,0.015)] mb-4 md:mb-8 w-full">
			</div>
		`);
		this.prepare_search();
		this.prepare_sort();
		this.prepare_view_toggler();

		if (this.needs_product_search_init()) {
			window._arac_product_search_inited = new aracwebshop.ProductSearch();
		}
	}

	prepare_view_toggler() {

		if (!$("#list").length || !$("#image-view").length) {
			this.render_view_toggler();
			this.bind_view_toggler_actions();
			this.set_view_state();
		}
	}

	get_item_filter_data(from_filters=false) {
		let me = this;
		if (this.isLoading) return;

		this.isLoading = true;
		this.from_filters = from_filters;
		let args = this.get_query_filters();
		const request_generation = this.request_generation;

		this.disable_view_toggler(true);

		let isFirstPage = (this.start === 0);
		args.include_count = isFirstPage ? 1 : 0;
		args.compact_settings = 1;
		if (isFirstPage) {
			$('#products-end-message').remove();
			$('#products-end-message-list').remove();
			this.prepare_product_area_wrapper("grid");
			this.prepare_product_area_wrapper("list");
			if (this.preference === "Grid View") {
				$("#products-grid-area").removeClass("hidden");
				$("#products-list-area").addClass("hidden");
			} else {
				$("#products-grid-area").addClass("hidden");
				$("#products-list-area").removeClass("hidden");
			}
		}
		this.show_shimmer_cards();

		frappe.call({
			method: "aracwebshop.aracwebshop.api.get_product_filter_data",
			args: {
				query_args: args
			},
			callback: function(result) {
				if (request_generation !== me.request_generation) return;

				me.isLoading = false;
				me.remove_shimmer_cards();
				me.disable_view_toggler(false);

				if (!result || result.exc || !result.message || result.message.exc) {
					if (isFirstPage) {
						me.render_no_products_section(true);
					}
				} else {
					if (isFirstPage && me.item_group && result.message["sub_categories"].length) {
						me.render_item_sub_categories(result.message["sub_categories"]);
					}

					let new_products = result.message["items"] || [];
					if (result.message["items_count"] !== null && result.message["items_count"] !== undefined) {
						me.product_count = Number(result.message["items_count"] || 0);
					}
					
					if (me.product_count !== null) {
						const count_label = `${me.product_count} ${me.product_count === 1 ? __('Product') : __('Products')}`;
						$("#header-product-count-badge .count-val").text(count_label);
					}

					if (isFirstPage && !new_products.length) {
						me.render_no_products_section();
						me.hasMore = false;
					} else {
						if (isFirstPage) {
							const filters = result.message["filters"] || {};
							me.re_render_discount_filters(filters.discount_filters);
						}

						me.append_products(new_products, result.message["settings"] || me.product_settings || {});
						
						me.start += new_products.length;
						
						let page_length = (me.product_settings && me.product_settings.products_per_page) || 10;
						const reached_known_total = me.product_count !== null && me.start >= me.product_count;
						if (reached_known_total || new_products.length < page_length) {
							me.hasMore = false;
							me.show_end_message();
						}
					}

					if (!from_filters && isFirstPage) {
						me.bind_filters();
						me.restore_filters_state();
					}

					if (me.hasMore) {
						window.requestAnimationFrame(() => me.maybe_load_more());
					}
				}
			}
		});
	}

	disable_view_toggler(disable=false) {
		$('#list').prop('disabled', disable);
		$('#image-view').prop('disabled', disable);
	}

	render_grid_view(items, settings) {
		// loop over data and add grid html to it
		let me = this;
		this.prepare_product_area_wrapper("grid");

		new aracwebshop.ProductGrid({
			items: items,
			products_section: $("#products-grid-area"),
			settings: settings,
			preference: me.preference
		});
	}

	render_list_view(items, settings) {
		let me = this;
		this.prepare_product_area_wrapper("list");

		new aracwebshop.ProductList({
			items: items,
			products_section: $("#products-list-area"),
			settings: settings,
			preference: me.preference
		});
	}

	prepare_product_area_wrapper(view) {
		let area = this.products_section.find(`#products-${view}-area`);
		if (area.length) return area;

		let classes = view === "grid" 
			? "grid arac-product-grid grid-cols-2 gap-2.5 md:gap-5 mt-6 -mx-1.5 md:mx-0 md:w-full"
			: "flex flex-col gap-6 w-full mt-6";
		this.products_section.append(`
			<div id="products-${view}-area" class="${classes}" itemscope itemtype="https://schema.org/Product"></div>
		`);
		return this.products_section.find(`#products-${view}-area`);
	}

	get_query_filters() {
		const filters = frappe.utils.get_query_params();
		let {field_filters, attribute_filters} = filters;

		field_filters = field_filters ? JSON.parse(field_filters) : {};
		attribute_filters = attribute_filters ? JSON.parse(attribute_filters) : {};
		const search_term = (filters.search || filters.search_term || "").trim();

		let query_obj = {
			field_filters: field_filters,
			attribute_filters: attribute_filters,
			item_group: this.item_group,
			start: this.start || 0,
			from_filters: this.from_filters || false,
			sort_by: filters.sort_by || null,
			sort_order: filters.sort_order || null,
			has_offer: filters.has_offer || null
		};

		if (search_term) {
			query_obj.search = search_term;
		}

		return query_obj;
	}

	add_paging_section(settings) {
		$(".product-paging-area").remove();

		if (this.products && this.product_count > 0) {
			let query_params = frappe.utils.get_query_params();
			let start = query_params.start ? cint(JSON.parse(query_params.start)) : 0;
			let page_length = settings.products_per_page || 10;
			let total_count = this.product_count;
			
			let current_page = Math.floor(start / page_length) + 1;
			let total_pages = Math.ceil(total_count / page_length);

			if (total_pages <= 1) return; // No pagination needed for a single page

			// Calculate product range display
			let start_index = start + 1;
			let end_index = Math.min(start + this.products.length, total_count);

			let count_text = __("Showing {0}–{1} of {2} products", [
				`<span class="font-bold text-slate-800">${start_index}</span>`,
				`<span class="font-bold text-slate-800">${end_index}</span>`,
				`<span class="font-bold text-slate-900">${total_count}</span>`
			]);

			// Page numbers algorithm
			let pages = [];
			const is_mobile = window.innerWidth < 500;
			if (is_mobile) {
				if (total_pages <= 4) {
					for (let i = 1; i <= total_pages; i++) pages.push(i);
				} else {
					if (current_page <= 2) {
						pages = [1, 2, '...', total_pages];
					} else if (current_page >= total_pages - 1) {
						pages = [1, '...', total_pages - 1, total_pages];
					} else {
						pages = [1, '...', current_page, '...', total_pages];
					}
				}
			} else {
				if (total_pages <= 7) {
					for (let i = 1; i <= total_pages; i++) pages.push(i);
				} else {
					if (current_page <= 4) {
						pages = [1, 2, 3, 4, 5, '...', total_pages];
					} else if (current_page >= total_pages - 3) {
						pages = [1, '...', total_pages - 4, total_pages - 3, total_pages - 2, total_pages - 1, total_pages];
					} else {
						pages = [1, '...', current_page - 1, current_page, current_page + 1, '...', total_pages];
					}
				}
			}

			// Generate HTML
			let paging_html = `
				<div class="product-paging-area flex flex-col items-center gap-3 mt-6 py-2 mb-1 border-t border-slate-100 w-full text-center">
					<div class="text-xs text-slate-500 font-semibold tracking-wide">
						${count_text}
					</div>
					<nav class="flex items-center gap-1 md:gap-1.5 justify-center" aria-label="Pagination">
			`;

			// Prev Button
			let prev_start = Math.max(0, start - page_length);
			let prev_disabled = start > 0 ? "" : "disabled";
			let prev_style_class = start > 0 
				? "text-slate-600 hover:bg-slate-100 hover:text-slate-900 active:scale-95" 
				: "text-slate-300 pointer-events-none opacity-50";

			paging_html += `
				<button class="btn-prev flex items-center justify-center w-8 h-8 md:w-9 md:h-9 rounded-lg md:rounded-xl border border-slate-200 bg-white font-bold transition-all ${prev_style_class}" 
					data-start="${prev_start}" ${prev_disabled} aria-label="Previous page">
					<svg class="w-3.5 h-3.5 md:w-4 md:h-4" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24">
						<path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
					</svg>
				</button>
			`;

			// Page numbers
			pages.forEach(p => {
				if (p === '...') {
					paging_html += `
						<span class="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center text-slate-400 font-bold text-xs md:text-sm">...</span>
					`;
				} else {
					let is_active = p === current_page;
					let active_class = is_active 
						? "bg-theme-primary text-white border-theme-primary shadow-md shadow-theme-primary/10 font-bold scale-105" 
						: "bg-white text-slate-600 border-slate-200 hover:bg-slate-100 hover:text-slate-900 hover:border-slate-350 active:scale-95";
					paging_html += `
						<button class="btn-page flex items-center justify-center w-8 h-8 md:w-9 md:h-9 rounded-lg md:rounded-xl border font-bold text-[11px] md:text-xs transition-all ${active_class}" 
							data-start="${(p - 1) * page_length}" aria-label="Go to page ${p}">
							${p}
						</button>
					`;
				}
			});

			// Next Button
			let next_start = start + page_length;
			let next_disabled = (total_count > next_start) ? "" : "disabled";
			let next_style_class = (total_count > next_start)
				? "text-slate-600 hover:bg-slate-100 hover:text-slate-900 active:scale-95"
				: "text-slate-300 pointer-events-none opacity-50";

			paging_html += `
				<button class="btn-next flex items-center justify-center w-8 h-8 md:w-9 md:h-9 rounded-lg md:rounded-xl border border-slate-200 bg-white font-bold transition-all ${next_style_class}" 
					data-start="${next_start}" ${next_disabled} aria-label="Next page">
					<svg class="w-3.5 h-3.5 md:w-4 md:h-4" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24">
						<path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
					</svg>
				</button>
			`;

			paging_html += `
					</nav>
				</div>
			`;

			$(".page_content").append(paging_html);
			this.bind_paging_action();
		}
	}

	prepare_toolbar() {
		if ($(".toolbar").length) {
			return;
		}

		const title_data = $("#item-group-title-data").data("title");
		const title_text = title_data || (this.item_group ? __(this.item_group) : __("All Products"));
		const filters_hidden = localStorage.getItem("hide_filters") === "true";
		const is_mobile = window.innerWidth < 768;

		this.products_section.append(`
			<div class="toolbar flex items-center justify-between gap-2 md:gap-3 bg-white/95 backdrop-blur-md px-3 py-2 md:px-4 md:py-2.5 rounded-xl md:rounded-2xl border border-slate-200/70 shadow-[0_2px_15px_rgba(0,0,0,0.02)] mb-3 md:mb-6 w-full">
				<div class="flex items-center gap-2 md:gap-3 min-w-0">
					<h1 class="text-sm md:text-lg font-black tracking-tight text-slate-900 m-0 leading-none truncate">${ title_text }</h1>
					<span id="header-product-count-badge" class="inline-flex items-center px-2 md:px-2.5 py-0.5 rounded-full text-[10px] md:text-xs font-semibold bg-theme-primary-light text-theme-primary border border-theme-primary/10 whitespace-nowrap shrink-0">
						<span class="count-val">${__("Loading...")}</span>
					</span>
				</div>
				<div class="toolbar-controls flex items-center gap-1.5 md:gap-2.5 shrink-0">
					<button id="filter-toggle-btn" class="inline-flex items-center gap-1 md:gap-1.5 px-2 md:px-3 py-1.5 border border-slate-200/80 rounded-lg md:rounded-xl bg-slate-50/80 hover:bg-white text-slate-700 hover:text-theme-primary hover:border-theme-primary/40 font-bold text-[11px] md:text-xs shadow-2xs transition-all cursor-pointer active:scale-95 focus:outline-none">
						<svg class="w-3.5 h-3.5 text-slate-500" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
							<path stroke-linecap="round" stroke-linejoin="round" d="M10.5 6h9.75M10.5 6a1.5 1.5 0 11-3 0m3 0a1.5 1.5 0 10-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 11-3 0m3 0a1.5 1.5 0 10-3 0M3.75 18H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 11-3 0m3 0a1.5 1.5 0 10-3 0M3.75 12h11.25" />
						</svg>
						<span>${ is_mobile ? __("Filters") : (filters_hidden ? __("Show Filters") : __("Hide Filters")) }</span>
					</button>
				</div>
			</div>
		`);
		this.prepare_search();
		this.prepare_sort();
		this.render_view_toggler();
		aracwebshop.bind_product_filter_shell();

		if (this.needs_product_search_init()) {
			window._arac_product_search_inited = new aracwebshop.ProductSearch();
		}
	}

	needs_product_search_init() {
		if (!$("#search-box, #search-box-mobile").length || !window.aracwebshop || !aracwebshop.ProductSearch) {
			return false;
		}
		const current = window._arac_product_search_inited;
		const dropdown = current && current.search_dropdown && current.search_dropdown[0];
		return !current || !dropdown || !document.body.contains(dropdown);
	}

	prepare_search() {
		if ($("#search-box, #search-box-mobile").length) {
			return;
		}
		$(".toolbar").append(`
			<div class="relative flex-1 min-w-0">
				<div class="dropdown w-full" id="dropdownMenuSearch">
					<input type="search" name="query" id="search-box" 
						class="w-full pl-10 pr-4 py-2 border border-slate-200/80 bg-slate-50/80 focus:bg-white text-slate-800 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-theme-primary/20 focus:border-theme-primary rounded-xl text-xs transition-all shadow-2xs"
						placeholder="${__("Search for Products...")}"
						aria-label="Product" aria-describedby="button-addon2">
					<div class="absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none rtl:right-3.5 rtl:left-auto">
						<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
							fill="none"
							stroke="currentColor" stroke-width="2" stroke-linecap="round"
							stroke-linejoin="round">
							<circle cx="11" cy="11" r="8"></circle>
							<line x1="21" y1="21" x2="16.65" y2="16.65"></line>
						</svg>
					</div>
				</div>
			</div>
		`);
	}

	prepare_sort() {
		const filters = frappe.utils.get_query_params();
		const current_sort_by = filters.sort_by || "modified";
		const current_sort_order = filters.sort_order || "desc";
		
		const sort_options = [
			{ label: __("Latest Arrivals"), by: "modified", order: "desc" },
			{ label: __("Oldest Products"), by: "creation", order: "asc" },
			{ label: __("Price (lowest first)"), by: "price", order: "asc" },
			{ label: __("Price (highest first)"), by: "price", order: "desc" },
			{ label: __("Alphabetical: A-Z"), by: "web_item_name", order: "asc" },
			{ label: __("Alphabetical: Z-A"), by: "web_item_name", order: "desc" }
		];

		let options_html = "";
		sort_options.forEach(opt => {
			const selected = (current_sort_by === opt.by && current_sort_order === opt.order) ? "selected" : "";
			options_html += `<option value="${opt.by}:${opt.order}" ${selected}>${opt.label}</option>`;
		});

		// Desktop-only Sort dropdown inside toolbar-controls
		$(".toolbar-controls").append(`
			<div class="relative sort-container shrink-0 d-none d-md-block">
				<div class="relative flex items-center">
					<select id="product-sort-select" class="pl-3 pr-7 py-1.5 border border-slate-200/80 bg-slate-50/80 hover:bg-white text-xs font-bold text-slate-700 focus:bg-white focus:outline-none focus:ring-2 focus:ring-theme-primary/20 focus:border-theme-primary rounded-xl appearance-none cursor-pointer product-sort-picker transition-all shadow-2xs">
						${options_html}
					</select>
					<div class="absolute right-2.5 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none rtl:left-2.5 rtl:right-auto">
						<svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
							<path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
						</svg>
					</div>
				</div>
			</div>
		`);

		// Mobile-only Sort Card in Filter Sidebar
		const mobile_sort_html = `
			<div class="d-block d-md-none bg-white/75 backdrop-blur-md border border-slate-100/80 rounded-[1.5rem] p-5 shadow-[0_8px_30px_rgb(0,0,0,0.015)] flex flex-col gap-3 mb-4">
				<div class="text-xs font-black text-slate-900 tracking-wider uppercase">${__("Sort By")}</div>
				<div class="relative w-full">
					<select id="product-sort-select-mobile" class="w-full px-4 py-2.5 pr-8 border border-slate-200/80 bg-slate-50 text-xs font-bold text-slate-700 focus:outline-none focus:ring-2 focus:ring-theme-primary/20 rounded-xl appearance-none cursor-pointer product-sort-picker">
						${options_html}
					</select>
					<div class="absolute right-3.5 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none rtl:left-3.5 rtl:right-auto">
						<svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
							<path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
						</svg>
					</div>
				</div>
			</div>
		`;
		$("#filter-sidebar .w-full.flex-col").prepend(mobile_sort_html);

		// Bind change event
		let me = this;
		$(".product-sort-picker").off("change").on("change", function() {
			const val = $(this).val().split(":");
			const sort_by = val[0];
			const sort_order = val[1];

			let route_params = frappe.utils.get_query_params();
			route_params.sort_by = sort_by;
			route_params.sort_order = sort_order;
			route_params.start = 0; // reset page

			const query_string = me.get_query_string({
				start: 0,
				field_filters: JSON.stringify(me.if_key_exists(me.field_filters)),
				attribute_filters: JSON.stringify(me.if_key_exists(me.attribute_filters)),
				sort_by: sort_by,
				sort_order: sort_order
			});
			window.history.pushState('filters', '', `${location.pathname}?` + query_string);

			me.make(true);
		});
	}

	render_view_toggler() {
		$(".toolbar-controls").append(`
			<div class="toggle-container d-none d-md-flex items-center p-0.5 rounded-xl bg-slate-100/90 border border-slate-200/60 gap-0.5 shrink-0 shadow-2xs">
			</div>
		`);

		["btn-list-view", "btn-grid-view"].forEach(view => {
			let icon = view === "btn-list-view" ? "list" : "image-view";
			let icon_title = view === "btn-list-view" ? __("List View") : __("Grid View");
			let icon_svg = icon === "list" ? 
				`<svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" /></svg>` :
				`<svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6A2.25 2.25 0 016 3.75h2.25A2.25 2.25 0 0110.5 6v2.25a2.25 2.25 0 01-2.25 2.25H6a2.25 2.25 0 01-2.25-2.25V6zM3.75 15.75A2.25 2.25 0 016 13.5h2.25a2.25 2.25 0 012.25 2.25V18a2.25 2.25 0 01-2.25 2.25H6A2.25 2.25 0 013.75 18v-2.25zM13.5 6a2.25 2.25 0 012.25-2.25H18A2.25 2.25 0 0120.25 6v2.25A2.25 2.25 0 0118 10.5h-2.25a2.25 2.25 0 01-2.25-2.25V6zM13.5 15.75a2.25 2.25 0 012.25-2.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25h-2.25A2.25 2.25 0 0113.5 18v-2.25z" /></svg>`;

			$(".toggle-container").append(`
				<button id="${ icon }" class="btn-toggler p-1.5 rounded-lg border-none bg-transparent text-slate-500 hover:text-slate-900 transition-all duration-200 focus:outline-none cursor-pointer flex items-center justify-center" title="${ icon_title }">
					${ icon_svg }
				</button>
			`);
		});

		this.bind_view_toggler_actions();
		this.set_view_state();
	}

	bind_view_toggler_actions() {
		let me = this;
		$(document).off("click", "#list").on("click", "#list", function() {
			let $btn = $(this);
			$btn.removeClass("bg-transparent text-slate-500").addClass("bg-theme-primary text-white shadow-xs scale-[1.02]");
			$("#image-view").removeClass("bg-theme-primary text-white shadow-xs scale-[1.02]").addClass("bg-transparent text-slate-500");

			localStorage.setItem("product_view", "List View");
			me.preference = "List View";
			me.ensure_view_rendered("list");
			$("#products-grid-area").addClass("hidden");
			$("#products-list-area").removeClass("hidden");
			if (!me.hasMore) me.show_end_message();
		});

		$(document).off("click", "#image-view").on("click", "#image-view", function() {
			let $btn = $(this);
			$btn.removeClass("bg-transparent text-slate-500").addClass("bg-theme-primary text-white shadow-xs scale-[1.02]");
			$("#list").removeClass("bg-theme-primary text-white shadow-xs scale-[1.02]").addClass("bg-transparent text-slate-500");

			localStorage.setItem("product_view", "Grid View");
			me.preference = "Grid View";
			me.ensure_view_rendered("grid");
			$("#products-list-area").addClass("hidden");
			$("#products-grid-area").removeClass("hidden");
			if (!me.hasMore) me.show_end_message();
		});
	}

	set_view_state() {
		if (this.preference === "List View") {
			$("#list").removeClass("bg-transparent text-slate-500").addClass("bg-theme-primary text-white shadow-xs scale-[1.02]");
			$("#image-view").removeClass("bg-theme-primary text-white shadow-xs scale-[1.02]").addClass("bg-transparent text-slate-500");
		} else {
			$("#image-view").removeClass("bg-transparent text-slate-500").addClass("bg-theme-primary text-white shadow-xs scale-[1.02]");
			$("#list").removeClass("bg-theme-primary text-white shadow-xs scale-[1.02]").addClass("bg-transparent text-slate-500");
		}
	}

	bind_paging_action() {
		let me = this;
		$('.btn-prev, .btn-next, .btn-page').click((e) => {
			const $btn = $(e.currentTarget);
			me.from_filters = false;

			$btn.prop('disabled', true);
			const start = $btn.data('start');

			let query_params = frappe.utils.get_query_params();
			query_params.start = start;
			let path = window.location.pathname + '?' + frappe.utils.get_url_from_dict(query_params);
			if (window.aracPjaxNavigate) {
				window.aracPjaxNavigate(path);
			} else {
				window.location.href = path;
			}
		});
	}

	re_render_discount_filters(filter_data) {
		this.get_discount_filter_html(filter_data);
		if (this.from_filters) {
			// Bind filter action if triggered via filters
			// if not from filter action, page load will bind actions
			this.bind_discount_filter_action();
		}
		// discount filters are rendered with Items (later)
		// unlike the other filters
		this.restore_discount_filter();
	}

	get_discount_filter_html(filter_data) {
		$("#discount-filters").remove();
		if (filter_data) {
			$("#product-filters").append(`
				<div id="discount-filters" class="mb-4 filter-block pb-5">
					<div class="filter-label mb-3">${ __("Discounts") }</div>
				</div>
			`);

			let html = `<div class="filter-options">`;
			filter_data.forEach(filter => {
				html += `
					<div class="checkbox">
						<label data-value="${ filter[0] }">
							<input type="radio"
								class="product-filter discount-filter"
								name="discount" id="${ filter[0] }"
								data-filter-name="discount"
								data-filter-value="${ filter[0] }"
								style="width: 14px !important"
							>
								<span class="label-area" for="${ filter[0] }">
									${ filter[1] }
								</span>
						</label>
					</div>
				`;
			});
			html += `</div>`;

			$("#discount-filters").append(html);
		}
	}

	restore_discount_filter() {
		const filters = frappe.utils.get_query_params();
		let field_filters = filters.field_filters;
		if (!field_filters) return;

		field_filters = JSON.parse(field_filters);

		if (field_filters && field_filters["discount"]) {
			const values = field_filters["discount"];
			const selector = values.map(value => {
				return `input[data-filter-name="discount"][data-filter-value="${value}"]`;
			}).join(',');
			$(selector).prop('checked', true);
			this.field_filters = field_filters;
		}
	}

	bind_discount_filter_action() {
		let me = this;
		$('.discount-filter').on('change', (e) => {
			const $checkbox = $(e.target);
			const is_checked = $checkbox.is(':checked');

			const {
				filterValue: filter_value
			} = $checkbox.data();

			delete this.field_filters["discount"];

			if (is_checked) {
				this.field_filters["discount"] = [];
				this.field_filters["discount"].push(filter_value);
			}

			if (this.field_filters["discount"].length === 0) {
				delete this.field_filters["discount"];
			}

			me.change_route_with_filters();
		});
	}

	bind_filters() {
		let me = this;
		this.field_filters = {};
		this.attribute_filters = {};

		$('.product-filter').on('change', (e) => {
			me.from_filters = true;

			const $checkbox = $(e.target);
			const is_checked = $checkbox.is(':checked');

			if ($checkbox.data('filter-name') === 'item_group') {
				const $treeItem = $checkbox.closest('.tree-item');
				
				// 1. Propagate checked state down to all descendant checkboxes
				$treeItem.find('.tree-children input.product-filter').prop('checked', is_checked);

				// 2. Propagate state up to ancestor checkboxes
				if (!is_checked) {
					// If unchecking a child, uncheck all parents up the tree
					$checkbox.parents('.tree-item').each(function() {
						$(this).find('> .tree-row input.product-filter').prop('checked', false);
					});
				} else {
					// If checking a child, check parents if all their children (siblings) are checked
					let $current = $treeItem;
					while ($current.parent().hasClass('tree-children')) {
						const $parentTreeItem = $current.parent().closest('.tree-item');
						const $siblings = $current.parent().find('> .tree-item > .tree-row input.product-filter');
						const all_checked = $siblings.filter(':checked').length === $siblings.length;
						$parentTreeItem.find('> .tree-row input.product-filter').prop('checked', all_checked);
						$current = $parentTreeItem;
					}
				}

				// 3. Rebuild the field_filters['item_group'] array dynamically from all checked inputs
				this.field_filters['item_group'] = [];
				$('.item-group-tree input.product-filter:checked').each((i, el) => {
					const val = $(el).data('filter-value');
					if (val) {
						this.field_filters['item_group'].push(val);
					}
				});
				if (this.field_filters['item_group'].length === 0) {
					delete this.field_filters['item_group'];
				}
			} else if ($checkbox.is('.attribute-filter')) {
				const {
					attributeName: attribute_name,
					attributeValue: attribute_value
				} = $checkbox.data();

				if (is_checked) {
					this.attribute_filters[attribute_name] = this.attribute_filters[attribute_name] || [];
					this.attribute_filters[attribute_name].push(attribute_value);
				} else {
					this.attribute_filters[attribute_name] = this.attribute_filters[attribute_name] || [];
					this.attribute_filters[attribute_name] = this.attribute_filters[attribute_name].filter(v => v !== attribute_value);
				}

				if (this.attribute_filters[attribute_name].length === 0) {
					delete this.attribute_filters[attribute_name];
				}
			} else if ($checkbox.is('.field-filter') || $checkbox.is('.discount-filter')) {
				const {
					filterName: filter_name,
					filterValue: filter_value
				} = $checkbox.data();

				if ($checkbox.is('.discount-filter')) {
					// clear previous discount filter to accomodate new
					delete this.field_filters["discount"];
				}
				if (is_checked) {
					this.field_filters[filter_name] = this.field_filters[filter_name] || [];
					if (!in_list(this.field_filters[filter_name], filter_value)) {
						this.field_filters[filter_name].push(filter_value);
					}
				} else {
					this.field_filters[filter_name] = this.field_filters[filter_name] || [];
					this.field_filters[filter_name] = this.field_filters[filter_name].filter(v => v !== filter_value);
				}

				if (this.field_filters[filter_name].length === 0) {
					delete this.field_filters[filter_name];
				}
			}

			me.change_route_with_filters();
		});

		// bind filter lookup input box
		$('.filter-lookup-input').on('keydown', frappe.utils.debounce((e) => {
			const $input = $(e.target);
			const keyword = ($input.val() || '').toLowerCase();
			const $filter_options = $input.next('.filter-options');

			$filter_options.find('.filter-lookup-wrapper').show();
			$filter_options.find('.filter-lookup-wrapper').each((i, el) => {
				const $el = $(el);
				const value = $el.data('value').toLowerCase();
				if (!value.includes(keyword)) {
					$el.hide();
				}
			});
		}, 300));
	}

	change_route_with_filters() {
		let route_params = frappe.utils.get_query_params();

		let start = this.if_key_exists(route_params.start) || 0;
		if (this.from_filters) {
			start = 0; // show items from first page if new filters are triggered
		}

		const query_string = this.get_query_string({
			start: start,
			field_filters: JSON.stringify(this.if_key_exists(this.field_filters)),
			attribute_filters: JSON.stringify(this.if_key_exists(this.attribute_filters)),
			sort_by: route_params.sort_by || undefined,
			sort_order: route_params.sort_order || undefined
		});
		window.history.pushState('filters', '', `${location.pathname}?` + query_string);

		$('.page_content input').prop('disabled', true);

		this.make(true);
		$('.page_content input').prop('disabled', false);
	}

	restore_filters_state() {
		const filters = frappe.utils.get_query_params();
		let {field_filters, attribute_filters} = filters;

		if (field_filters) {
			field_filters = JSON.parse(field_filters);
			for (let fieldname in field_filters) {
				const values = field_filters[fieldname];
				const selector = values.map(value => {
					return `input[data-filter-name="${fieldname}"][data-filter-value="${value}"]`;
				}).join(',');
				$(selector).prop('checked', true);
			}
			this.field_filters = field_filters;
		}
		if (attribute_filters) {
			attribute_filters = JSON.parse(attribute_filters);
			for (let attribute in attribute_filters) {
				const values = attribute_filters[attribute];
				const selector = values.map(value => {
					return `input[data-attribute-name="${attribute}"][data-attribute-value="${value}"]`;
				}).join(',');
				$(selector).prop('checked', true);
			}
			this.attribute_filters = attribute_filters;
		}

		// Expand parent nodes of checked inputs in the tree
		$('.item-group-tree input:checked').each(function() {
			$(this).parents('.tree-children').removeClass('hidden').show();
			$(this).parents('.tree-item').find('> .tree-row .tree-chevron').addClass('rotate-90');
		});
	}

	render_no_products_section(error=false) {
		let error_section = `
			<div class="mt-4 w-full p-6 text-center bg-rose-50 border border-rose-100 rounded-3xl text-rose-800 text-xs font-black shadow-xs">
				<span class="text-lg mr-2">⚠️</span>
				${ __("Something went wrong. Please refresh or contact us.") }
			</div>
		`;
		let no_results_section = `
			<div class="w-full flex flex-col items-center justify-center py-16 px-4 text-center bg-white rounded-3xl border border-slate-100 shadow-sm mt-4">
				<div class="w-20 h-20 bg-slate-50 rounded-full flex items-center justify-center text-slate-400 mb-6 border border-slate-100/50 shadow-2xs">
					<svg class="w-10 h-10 text-slate-300" fill="none" stroke="currentColor" stroke-width="1.8" viewBox="0 0 24 24">
						<path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.637 10.637z"></path>
					</svg>
				</div>
				<h3 class="text-xs font-black text-slate-900 mb-2 uppercase tracking-wider">
					${ __("No products found") }
				</h3>
				<p class="text-[11px] text-slate-500 font-semibold max-w-sm mb-6 leading-relaxed">
					${ __("We couldn't find any products matching your selection. Try adjusting your filters or search term to discover available items.") }
				</p>
				<div class="flex items-center justify-center gap-3">
					<a href="/all-products" class="px-4 py-2 bg-slate-900 hover:bg-theme-primary text-white text-xs font-black rounded-xl transition-all duration-200 shadow-sm cursor-pointer no-underline">
						${ __("Reset Filters") }
					</a>
					<a href="/" class="px-4 py-2 bg-slate-100 hover:bg-slate-200 text-slate-700 text-xs font-black rounded-xl transition-all duration-200 cursor-pointer no-underline">
						${ __("Go to Home") }
					</a>
				</div>
			</div>
		`;

		this.products_section.append(error ? error_section : no_results_section);
	}

	render_item_sub_categories(categories) {
		if (categories && categories.length) {
			const escape_html = value => $('<div>').text(value || '').html();
			let sub_group_html = `
				<div class="sub-categories-wrapper w-full mb-3 relative">
					<div class="sub-categories-scroll-outer relative w-full overflow-hidden">
						<!-- Optional Tablet Scroll Arrows -->
						<button class="scroll-arrow scroll-arrow-left flex items-center justify-center" type="button" aria-label="${ __("Scroll left") }">
							<svg class="w-3.5 h-3.5 stroke-[2.5]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
								<path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
							</svg>
						</button>

						<div class="sub-categories-scroll-container no-scrollbar">
			`;

			categories.forEach(category => {
				const category_name = escape_html(category.name);
				const category_route = escape_html(category.route || '#');
				const category_image = escape_html(category.image || '');
				const avatar_html = category_image
					? `<span class="sub-category-pill-media"><img src="${ category_image }" alt="${ category_name }" onerror="this.parentElement.innerHTML='<span class=&quot;sub-category-pill-dot&quot; aria-hidden=&quot;true&quot;></span>';"></span>`
					: `<span class="sub-category-pill-dot" aria-hidden="true"></span>`;

				sub_group_html += `
					<a href="/${ category_route }" class="sub-category-pill">
						${ avatar_html }
						<span class="sub-category-pill-label">${ category_name }</span>
					</a>
				`;
			});

			sub_group_html += `
						</div>

						<button class="scroll-arrow scroll-arrow-right flex items-center justify-center" type="button" aria-label="${ __("Scroll right") }">
							<svg class="w-3.5 h-3.5 stroke-[2.5]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
								<path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
							</svg>
						</button>
					</div>
			`;

			if (categories.length > 6) {
				sub_group_html += `
					<div class="sub-categories-expand-row flex justify-center mt-0.5">
						<button class="expand-pills-btn inline-flex items-center gap-1 text-[10px] font-black text-slate-500 hover:text-theme-primary transition-colors cursor-pointer active:scale-95" type="button">
							<span class="btn-text">${ __("Show All") }</span>
							<svg class="w-3 h-3 transform transition-transform duration-200" fill="none" viewBox="0 0 24 24" stroke="currentColor">
								<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M19 9l-7 7-7-7" />
							</svg>
						</button>
					</div>
				`;
			}

			sub_group_html += `
				</div>
			`;

			$("#product-listing").prepend(sub_group_html);
		}
	}

	get_query_string(object) {
		const url = new URLSearchParams();
		for (let key in object) {
			const value = object[key];
			if (value) {
				url.append(key, value);
			}
		}
		return url.toString();
	}

	if_key_exists(obj) {
		let exists = false;
		for (let key in obj) {
			if (Object.prototype.hasOwnProperty.call(obj, key) && obj[key]) {
				exists = true;
				break;
			}
		}
		return exists ? obj : undefined;
	}

	append_products(items, settings) {
		this.product_settings = settings || this.product_settings || {};
		this.prepare_product_area_wrapper("grid");
		this.prepare_product_area_wrapper("list");

		const unique_items = [];
		(items || []).forEach((item) => {
			const item_code = String(item.item_code || item.name || item.route || "");
			if (!item_code || this.loaded_product_codes.has(item_code)) return;
			this.loaded_product_codes.add(item_code);
			this.loaded_products.push(item);
			unique_items.push(item);
		});

		const active_view = this.preference === "List View" ? "list" : "grid";
		this.render_items_for_view(unique_items, active_view);

		if (active_view === "grid") {
			$("#products-grid-area").removeClass("hidden");
			$("#products-list-area").addClass("hidden");
		} else {
			$("#products-grid-area").addClass("hidden");
			$("#products-list-area").removeClass("hidden");
		}

		aracwebshop.aracwebshop.shopping_cart.bind_add_to_cart_action();
		aracwebshop.aracwebshop.wishlist.bind_wishlist_action();
	}

	render_items_for_view(items, view) {
		if (!items || !items.length) return;

		const is_grid = view === "grid";
		const Renderer = is_grid ? aracwebshop.ProductGrid : aracwebshop.ProductList;
		if (!Renderer) return;

		const rendered_codes = this.rendered_product_codes[view];
		const missing_items = items.filter((item) => {
			const item_code = String(item.item_code || item.name || item.route || "");
			return item_code && !rendered_codes.has(item_code);
		});
		if (!missing_items.length) return;

		const section = this.prepare_product_area_wrapper(view);
		section.find("#products-end-message, #products-end-message-list").remove();

		const detached_container = document.createElement("div");
		new Renderer({
			items: missing_items,
			settings: this.product_settings || {},
			preference: is_grid ? "Grid View" : "List View",
			products_section: $(detached_container)
		});

		const fragment = document.createDocumentFragment();
		while (detached_container.firstChild) {
			fragment.appendChild(detached_container.firstChild);
		}
		section[0].appendChild(fragment);
		this.observe_product_images(section[0]);

		missing_items.forEach((item) => {
			const item_code = String(item.item_code || item.name || item.route || "");
			rendered_codes.add(item_code);
		});
	}

	reset_product_image_observer() {
		if (this.product_image_observer) {
			this.product_image_observer.disconnect();
			this.product_image_observer = null;
		}

		if (!window.IntersectionObserver) return;

		const preload_margin = Math.max(1200, (window.innerHeight || 800) * 2);
		this.product_image_observer = new window.IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				const image = entry.target;
				const source = image.getAttribute("data-arac-image-src");
				if (!source) return;

				if (entry.isIntersecting) {
					if (!image.getAttribute("src")) image.setAttribute("src", source);
					image.classList.remove("arac-image-unloaded");
					return;
				}

				// Card image containers have a fixed aspect ratio, so releasing the
				// decoded bitmap cannot move the page or disturb scroll restoration.
				if (image.getAttribute("src")) {
					image.removeAttribute("src");
					image.classList.add("arac-image-unloaded");
				}
			});
		}, {
			root: null,
			rootMargin: `${preload_margin}px 0px`,
			threshold: 0
		});
	}

	observe_product_images(scope) {
		if (!this.product_image_observer || !scope || !scope.querySelectorAll) return;

		scope.querySelectorAll("img.arac-product-card-image[data-arac-image-src]").forEach((image) => {
			if (image.getAttribute("data-arac-image-observed") === "1") return;
			image.setAttribute("data-arac-image-observed", "1");
			this.product_image_observer.observe(image);
		});
	}

	destroy() {
		if (this.product_image_observer) {
			this.product_image_observer.disconnect();
			this.product_image_observer = null;
		}
		$(window).off("scroll.product_listing");
	}

	ensure_view_rendered(view) {
		this.sync_loaded_product_state_from_dom();
		this.render_items_for_view(this.loaded_products, view);
		aracwebshop.aracwebshop.shopping_cart.bind_add_to_cart_action();
		aracwebshop.aracwebshop.wishlist.bind_wishlist_action();
	}

	sync_loaded_product_state_from_dom() {
		this.loaded_products.forEach((item) => {
			const item_code = String(item.item_code || "");
			if (!item_code) return;

			const $cards = $("#products-grid-area .item-card, #products-list-area .item-card").filter(function() {
				return String($(this).attr("data-item-code") || "") === item_code;
			});
			const $card = $cards.filter(":visible").first().length ? $cards.filter(":visible").first() : $cards.first();
			if (!$card.length) return;

			const $cart_overlay = $card.find(".cart-btn-overlay-container").first();
			if ($cart_overlay.length) {
				const quantity = parseInt(
					$cart_overlay.find(".input-cart-qty").val()
					|| $cart_overlay.find(".btn-cart-collapsed").attr("data-qty")
					|| "0",
					10
				) || 0;
				item.in_cart_qty = quantity;
				item.in_cart = quantity > 0;
			}

			const $template_badge = $card.find(".arac-template-cart-badge").first();
			if ($template_badge.length) {
				item.variant_in_cart_qty = parseFloat($template_badge.attr("data-template-cart-qty") || "0") || 0;
			}

			const $wishlist = $card.find(".like-action, .like-action-list").first();
			if ($wishlist.length) {
				item.wished = $wishlist.hasClass("like-action-wished");
			}
		});
	}

	show_shimmer_cards() {
		const skeleton = window.aracProductSkeleton;
		if (!skeleton) return;

		const active_view = this.preference === "List View" ? "list" : "grid";
		const section = this.prepare_product_area_wrapper(active_view);
		section.append(skeleton.cards(this.get_shimmer_card_count(active_view, section), active_view));
	}

	get_shimmer_card_count(active_view, section) {
		if (active_view === "list") {
			return window.innerWidth < 640 ? 1 : 2;
		}

		const element = section && section[0];
		if (element && window.getComputedStyle) {
			const columns = window.getComputedStyle(element).gridTemplateColumns;
			const visible_tracks = String(columns || "")
				.split(/\s+/)
				.filter((track) => track && track !== "none" && track !== "0px").length;
			if (visible_tracks) {
				return Math.max(2, Math.min(visible_tracks, 6));
			}
		}

		if (window.innerWidth < 640) return 2;
		return window.innerWidth >= 1280 ? 5 : 4;
	}

	remove_shimmer_cards() {
		$("#products-grid-area, #products-list-area")
			.find(".arac-product-skeleton")
			.remove();
	}

	show_end_message() {
		let textVal = typeof __ !== 'undefined' ? __("You've reached the end.") : "You've reached the end.";
		const active_view = this.preference === "List View" ? "list" : "grid";
		const message_id = active_view === "grid" ? "products-end-message" : "products-end-message-list";
		const message_class = active_view === "grid" ? "col-span-full" : "";

		$("#products-end-message, #products-end-message-list").remove();
		this.prepare_product_area_wrapper(active_view).append(`
			<div id="${message_id}" class="${message_class} text-center py-8 text-slate-400 font-bold text-xs tracking-wider uppercase select-none w-full">
				${textVal}
			</div>
		`);
	}

	maybe_load_more() {
		if (this.isLoading || !this.hasMore) return;
		const preload_distance = Math.max(1400, window.innerHeight * 1.5);
		const distance_to_bottom = document.documentElement.scrollHeight - (window.scrollY + window.innerHeight);
		if (distance_to_bottom <= preload_distance) {
			this.get_item_filter_data(this.from_filters);
		}
	}

	bind_infinite_scroll() {
		let me = this;
		$(window).off("scroll.product_listing");

		$(window).on("scroll.product_listing", function() {
			if (me.scroll_check_scheduled) return;
			me.scroll_check_scheduled = true;
			window.requestAnimationFrame(() => {
				me.scroll_check_scheduled = false;
				me.maybe_load_more();
			});
		});
	}
};
